<template lang="pug">
  div#app
    h1 Fake SWBC LoS
    navigation(:routes="routes")
    router-view
</template>

<script>
  import Navigation from '@/components/Navigation'
  import routes from '@/routes/index'
  export default {
    name: 'App',
    data () {
      return {
        routes
      }
    },
    components: {
      Navigation
    }
  }
</script>

<style lang="sass">
  @import ./styles/core.sass
  #app
    padding-top: 25px
    font-family: 'Avenir', Helvetica, Arial, sans-serif
    -webkit-font-smoothing: antialiased
    -moz-osx-font-smoothing: grayscale
    text-align: center
    color: #2c3e50
    h1
      margin-top: 30px
</style>
